var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_NewSupplierApplication"),
        width: _vm.$selectByLang("850px", "850px", "950px"),
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "supplier-application-form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-width": _vm.$selectByLang("140px", "140px", "180px"),
            "label-position": "left"
          }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("baseInfo.partner.cnShortName"),
                        prop: "cnShortName"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "cnShortName",
                          maxlength: 64,
                          disabled: true
                        },
                        model: {
                          value: _vm.form.cnShortName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "cnShortName", $$v)
                          },
                          expression: "form.cnShortName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_DomesticOverseas"),
                        prop: "oversea"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { no: "oversea" },
                          model: {
                            value: _vm.form.oversea,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "oversea", $$v)
                            },
                            expression: "form.oversea"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_Domestic"),
                              value: false
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_International"),
                              value: true
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_ChineseNamed"),
                        prop: "chineseName"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "chineseName", maxlength: 200 },
                        model: {
                          value: _vm.form.chineseName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "chineseName", $$v)
                          },
                          expression: "form.chineseName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("baseInfo.partner.shortName"),
                        prop: "shortName"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "shortName", maxlength: 100 },
                        model: {
                          value: _vm.form.shortName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "shortName", $$v)
                          },
                          expression: "form.shortName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("baseInfo.partner.englishName"),
                        prop: "englishName"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "englishName", maxlength: 200 },
                        model: {
                          value: _vm.form.englishName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "englishName", $$v)
                          },
                          expression: "form.englishName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("Partners.isPeers"), prop: "peer" }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { no: "peer" },
                          model: {
                            value: _vm.form.peer,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "peer", $$v)
                            },
                            expression: "form.peer"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: _vm.$t("Message.Yes"), value: true }
                          }),
                          _c("el-option", {
                            attrs: { label: _vm.$t("Message.No"), value: false }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_ContractStatus2"),
                        prop: "signContract"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { no: "signContract" },
                          model: {
                            value: _vm.form.signContract,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "signContract", $$v)
                            },
                            expression: "form.signContract"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_NoContract"),
                              value: false
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_HasContract"),
                              value: true
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.Addr"),
                        prop: "address"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "address", maxlength: 500 },
                        model: {
                          value: _vm.form.address,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "address", $$v)
                          },
                          expression: "form.address"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { "padding-top": "10px" },
              attrs: { label: _vm.$t("CargoMsg.Cargo_RuleRole") }
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: { "margin-left": "-10px" },
                      attrs: { span: 5 }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.bookingAgent,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "bookingAgent", $$v)
                            },
                            expression: "form.bookingAgent"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.BookingOrExchangeAgent"))
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.seaCmpAgent,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "seaCmpAgent", $$v)
                            },
                            expression: "form.seaCmpAgent"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.CarrierAgent")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.overseaAgent,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "overseaAgent", $$v)
                            },
                            expression: "form.overseaAgent"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Payment.destinationAgent")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.designationAgent,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "designationAgent", $$v)
                            },
                            expression: "form.designationAgent"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("queryJob.nominatedAgent")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.localAgent,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "localAgent", $$v)
                            },
                            expression: "form.localAgent"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.LocalAgent")))]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.settlementAgent,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "settlementAgent", $$v)
                            },
                            expression: "form.settlementAgent"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Payment.settlementAgent")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.seaCmp,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "seaCmp", $$v)
                            },
                            expression: "form.seaCmp"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.ShippingCompany")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.airCmp,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "airCmp", $$v)
                            },
                            expression: "form.airCmp"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.AirlineCompany")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.customsBroker,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "customsBroker", $$v)
                            },
                            expression: "form.customsBroker"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.CustomsBroker")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.warehouse,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "warehouse", $$v)
                            },
                            expression: "form.warehouse"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Warehouse")))]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.truckCmp,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "truckCmp", $$v)
                            },
                            expression: "form.truckCmp"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Partners.isTruckCmp")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.shipper,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "shipper", $$v)
                            },
                            expression: "form.shipper"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Message.Shipper")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.consignee,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "consignee", $$v)
                            },
                            expression: "form.consignee"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Message.Consignee")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.notify,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "notify", $$v)
                            },
                            expression: "form.notify"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Message.Notify")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.portAgent,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "portAgent", $$v)
                            },
                            expression: "form.portAgent"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Partners.portAgent")))]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.forwardingAgent,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "forwardingAgent", $$v)
                            },
                            expression: "form.forwardingAgent"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Partners.forwardingAgent")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.loadingPlaceCompany,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "loadingPlaceCompany", $$v)
                            },
                            expression: "form.loadingPlaceCompany"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Partners.loadingPlaceCompany")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.signBillPlaceCompany,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "signBillPlaceCompany", $$v)
                            },
                            expression: "form.signBillPlaceCompany"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("Partners.signBillPlaceCompany"))
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.terminalCompany,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "terminalCompany", $$v)
                            },
                            expression: "form.terminalCompany"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Message.TerminalCompany")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.dischargePortCompany,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "dischargePortCompany", $$v)
                            },
                            expression: "form.dischargePortCompany"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("Partners.dischargePortCompany"))
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.destinationPortCompany,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "destinationPortCompany", $$v)
                            },
                            expression: "form.destinationPortCompany"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("Partners.destinationPortCompany"))
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.tradersSign,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "tradersSign", $$v)
                            },
                            expression: "form.tradersSign"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Partners.traders")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.factorySign,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "factorySign", $$v)
                            },
                            expression: "form.factorySign"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("Partners.Factory") +
                                "/" +
                                _vm.$t("Order.Producer")
                            )
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.other,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "other", $$v)
                            },
                            expression: "form.other"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Message.Other")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("Partners.relatedBusinessType"),
                prop: "relatedBusinessTypes"
              }
            },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { no: "seaExport" },
                  model: {
                    value: _vm.form.seaExport,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "seaExport", $$v)
                    },
                    expression: "form.seaExport"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("constant.systemConstants.SE")))]
              ),
              _c(
                "el-checkbox",
                {
                  attrs: { no: "seaImport" },
                  model: {
                    value: _vm.form.seaImport,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "seaImport", $$v)
                    },
                    expression: "form.seaImport"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("constant.systemConstants.SI")))]
              ),
              _c(
                "el-checkbox",
                {
                  attrs: { no: "airExport" },
                  model: {
                    value: _vm.form.airExport,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "airExport", $$v)
                    },
                    expression: "form.airExport"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("constant.systemConstants.AE")))]
              ),
              _c(
                "el-checkbox",
                {
                  attrs: { no: "airImport" },
                  model: {
                    value: _vm.form.airImport,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "airImport", $$v)
                    },
                    expression: "form.airImport"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("constant.systemConstants.AI")))]
              ),
              _c(
                "el-checkbox",
                {
                  attrs: { no: "railwayExport" },
                  model: {
                    value: _vm.form.railwayExport,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "railwayExport", $$v)
                    },
                    expression: "form.railwayExport"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("constant.systemConstants.RB")))]
              ),
              _c(
                "el-checkbox",
                {
                  attrs: { no: "integratedJob" },
                  model: {
                    value: _vm.form.integratedJob,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "integratedJob", $$v)
                    },
                    expression: "form.integratedJob"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("constant.systemConstants.IE")))]
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("CargoMsg.Cargo_SupplierFile"),
                prop: "customerProfile"
              }
            },
            [
              _c(
                "div",
                { staticClass: "upload-file-row" },
                [
                  _vm.hasUploadedFile("customerProfile")
                    ? [
                        _c("span", { staticClass: "upload-file-name" }, [
                          _vm._v(
                            _vm._s(_vm.getUploadedFileName("customerProfile"))
                          )
                        ]),
                        _c("el-button", {
                          staticClass: "upload-file-remove",
                          attrs: { type: "text", icon: "el-icon-close" },
                          on: {
                            click: function($event) {
                              return _vm.handleRemoveUpload("customerProfile")
                            }
                          }
                        })
                      ]
                    : _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.handleUpload("customerProfile")
                            }
                          }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("CargoMsg.Cargo_Upload")) + " "
                          )
                        ]
                      )
                ],
                2
              )
            ]
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("CargoMsg.Cargo_ApprovalSummary"),
                prop: "applicationReason",
                required: ""
              }
            },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 4,
                  maxlength: 500,
                  "show-word-limit": "",
                  no: "applicationReason"
                },
                model: {
                  value: _vm.form.applicationReason,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "applicationReason", $$v)
                  },
                  expression: "form.applicationReason"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { margin: "0 auto", width: "fit-content" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "submit" },
              on: { click: _vm.handleSubmit }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Submit")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
          )
        ],
        1
      ),
      _c("cargo-cloud-file-upload", {
        attrs: {
          visible: _vm.cloudFile.visible,
          job: _vm.cloudFile.job,
          lob: _vm.cloudFile.lob
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cloudFile, "visible", $event)
          },
          uploadDone: _vm.uploadSuccess
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }